module.exports = __webpack_public_path__ + "img/onca-vega-imagotipo-233x120.c3a01867.svg";